<template>
  <div class="Login">
    <div class="background-image">
      <div class="login-card-position">
        <el-card class="box-card login-card" v-loading="is_brokers_list_loading">
          <div class="logo-section">
            <img src="../assets/images/logo/logo1.png" class="cursor-pointer" style="width: 175px" @click="goToLink('/')" />
          </div>

          <div>
            <div v-if="is_broker_login">
              <div class="top-margin-10">
                <div class="font-09rem font-weight-600">
                  {{ sign_in_form ? 'Login in to StockAnts' : 'Sign Up' }}
                </div>

                <div class="font-07rem font-weight-500 top-margin-5">{{ sign_in_form ? 'Login' : 'Signup' }} in to StockAnts using your broker credentials</div>
              </div>
              <div class="search-input" v-if="brokers_list.length > 1">
                <el-input placeholder="Search your broker" size="mini" prefix-icon="el-icon-search" v-model="broker_search_query" clearable></el-input>
              </div>
              <div>
                <div class="top-margin-10 broker-card-section">
                  <el-row :gutter="15">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-for="(broker, index) in filtered_brokers" :key="index">
                      <div>
                        <el-card class="box-card broker-card cursor-pointer flex-center" v-on:click.native="getRedirectURLForBroker(broker)">
                          <div class="flex">
                            <img :src="serverHostName + '/' + broker.logo" style="width: 35px" />
                            <div class="font-07rem font-weight-500 left-margin-15" :style="[broker.title == 'Show More' ? { marginTop: '12px', color: '#2d2e8d' } : {}]">
                              {{ broker.title }}
                            </div>
                          </div>
                        </el-card>
                      </div>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="!brokers_list.length && !is_brokers_list_loading">
                      <div style="font-size: 0.9rem; font-weight: 500; color: #e72726; text-align: center; margin-top: 15px">No brokers available to login</div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>

            <div v-if="!is_broker_login">
              <div class="font-1rem font-weight-600">
                {{ sign_in_form ? 'Login in to StockAnts' : 'Signup' }}
              </div>

              <div v-if="sign_in_form">
                <div class="top-margin-10">
                  <div class="font-08rem font-weight-500 top-margin-5" style="color: #9f9f9f">
                    Using
                    {{ userType == 'Retail Investor' ? 'your StockAnts' : 'Market Expert' }}
                    credentials
                  </div>
                </div>

                <div class="top-margin-25" style="padding: 0 15px 20px 15px 0">
                  <div style="margin-bottom: 16px">
                    <div class="input-group-section">
                      <div
                        class="form-group"
                        :class="{
                          'not-empty': username.length,
                          'form-group--error': show_error_on_empty && $v.username.$error,
                        }"
                        style="margin-bottom: 5px"
                      >
                        <div class="form-group" :class="{ 'not-empty': username.length }">
                          <div style="display: flex; align-items: center; gap: 8px">
                            <!-- Country Code Dropdown -->
                            <el-select v-model="selectedCountryCode" v-if="!emailUsername" placeholder="Code" size="small" style="width: 140px; background-color: #f5f7fa" filterable :popper-class="'dropdown-with-search'" class="custom-select" :disabled="is_otp_sent">
                              <template #prefix>
                                <span v-if="selectedCountry">
                                  <img :src="selectedCountry.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 5px; padding-top: 8px; vertical-align: middle" />
                                </span>
                              </template>

                              <el-option v-for="country in countryCodes" :key="`${country.country_code}-${country.name}`" :label="`${country.country_code}`" :value="country.country_code">
                                <span class="custom-label" style="display: flex; align-items: center">
                                  <img :src="country.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 8px; vertical-align: middle" />
                                  <span style="margin-right: 8px">{{ country.country_code }}</span>
                                  {{ country.name }}
                                </span>
                              </el-option>
                            </el-select>

                            <!-- Mobile Number or Email ID Input -->
                            <el-input v-model="username" size="small" type="text" class="form-control" placeholder="Mobile number or Email ID" name="user" :disabled="is_otp_sent" @input="validateMobileNumber" style="flex-grow: 1"></el-input>
                          </div>
                        </div>
                      </div>

                      <!-- Error Messages -->
                      <div class="error" v-if="show_error_on_empty && !$v.username.required">Field is required</div>
                      <div class="error" v-if="show_error_on_empty && !$v.username.emailOrPhone">Please enter a valid Mobile number or Email ID</div>
                      <div class="error" v-if="username.length > 0 && !isValidMobileNumber">Mobile number must be {{ getMaxLength() }} digits for the selected country code.</div>
                    </div>
                    <div class="input-group-section" v-if="mobileUsername && is_otp_sent">
                      <div class="bottom-margin-10">
                        <div
                          class="form-group"
                          :class="{
                            'not-empty': mobile_otp.length,
                            'form-group--error': show_error_on_empty && $v.mobile_otp.$error,
                          }"
                        >
                          <el-input type="text" size="small" class="form-control" placeholder="Mobile OTP" v-model="mobile_otp" @input="setMobileOtp($event)"></el-input>
                        </div>

                        <div class="error" v-if="show_error_on_empty && !$v.mobile_otp.required">Field is required</div>
                        <div style="color: red; font-size: 0.75em" v-else-if="mobile_otp.length && show_error_on_empty && mo_no_validation">Mobile number be valid numbers only</div>
                      </div>
                    </div>

                    <div class="input-group-section" v-if="emailUsername">
                      <div
                        class="form-group"
                        :class="{
                          'not-empty': password.length,
                          'form-group--error': show_error_on_empty && $v.password.$error,
                        }"
                        style="margin-bottom: 5px; position: relative"
                      >
                        <img v-if="show_password" src="../assets/images/visibility.png" class="password-visibility" @click="show_password = !show_password" />
                        <img v-else src="../assets/images/eye.png" @click="show_password = !show_password" class="password-visibility" />

                        <el-input v-model="password" size="small" :type="show_password ? 'text' : 'password'" class="form-control" placeholder="Password" name="pass" @input="setPassword($event)" v-on:keyup.enter="login()"></el-input>
                      </div>
                      <div class="error" v-if="show_error_on_empty && !$v.password.required">Field is required</div>
                    </div>
                  </div>

                  <div class="flex-space-between">
                    <el-button v-if="mobileUsername && !is_otp_sent" class="btn-secondary-theme-filled" size="mini" style="width: 100%" v-on:click="generateOtpForLogin()" :loading="is_login_btn_loading">Generate OTP</el-button>
                    <el-button v-else-if="mobileUsername && is_otp_sent" class="btn-secondary-theme-filled" size="mini" style="width: 100%" v-on:click="verifyOtpForLogin()" :loading="is_login_btn_loading">Verify OTP</el-button>
                    <el-button v-else class="btn-secondary-theme-filled" size="mini" style="width: 100%" v-on:click="login()" :loading="is_login_btn_loading">Log In</el-button>
                  </div>

                  <div v-if="emailUsername" class="label-color top-margin-5 text-right font-weight-500" style="font-size: 0.7rem; cursor: pointer; color: #2d2e8d; width: 103px; margin-left: auto" @click="goToLink('/forgot-password')">Forgot password?</div>

                  <div class="flex-space-between font-07rem top-margin-5" v-if="mobileUsername && is_otp_sent">
                    <div style="color: #2d2e8d; cursor: pointer; font-weight: 500" @click="resetUserName()">Change Number</div>
                    <div style="color: #2d2e8d; cursor: pointer; font-weight: 500" @click="generateOtpForLogin()">Resend OTP</div>
                  </div>

                  <div v-if="sign_in_form && allowed_authentication.credential_enable && allowed_authentication.sign_up" class="font-07rem font-weight-600 cursor-pointer text-left top-margin-10">
                    Don't have an account ?
                    <span @click="toggleForm('signUp')" class="external-link-color">Sign Up</span>
                  </div>
                </div>
              </div>

              <div v-if="sign_up_form">
                <div class="top-margin-20">
                  <div class="bottom-margin-10">
                    <div
                      class="form-group"
                      :class="{
                        'not-empty': full_name.length,
                        'form-group--error': show_error_on_empty && $v.full_name.$error,
                      }"
                    >
                      <el-input type="text" size="small" class="form-control" placeholder="Full Name" v-model="full_name" :disabled="is_otp_sent" @input="setFullName($event)"></el-input>
                    </div>

                    <div class="error" v-if="show_error_on_empty && !$v.full_name.required">Field is required</div>
                  </div>

                  <div class="bottom-margin-10 mobile-input">
                    <div
                      class="form-group"
                      :class="{
                        'not-empty': mobile_number.length,
                        'form-group--error': show_error_on_empty && $v.mobile_number.$error,
                      }"
                    >
                      <div style="display: flex; align-items: center; gap: 8px">
                        <!-- Country Code Dropdown -->
                        <el-select v-model="selectedCountryCode" v-if="!emailUsername" placeholder="Code" size="mini" style="width: 140px; background-color: #f5f7fa" filterable :popper-class="'dropdown-with-search'" class="custom-select" :disabled="is_otp_sent">
                          <template #prefix>
                            <span v-if="selectedCountry">
                              <img :src="selectedCountry.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 5px; padding-top: 6px; vertical-align: middle" />
                            </span>
                          </template>

                          <el-option v-for="country in countryCodes" :key="`${country.country_code}-${country.name}`" :label="`${country.country_code}`" :value="country.country_code">
                            <span class="custom-label" style="display: flex; align-items: center">
                              <img :src="country.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 8px; vertical-align: middle" />
                              <span style="margin-right: 8px">{{ country.country_code }}</span>
                              {{ country.name }}
                            </span>
                          </el-option>
                        </el-select>
                        <!-- Mobile Number Input -->
                        <el-input placeholder="xxx xxx xxxx" v-model="mobile_number" :maxlength="getMaxLength()" size="mini" @input="validateMobileNumber" style="flex-grow: 1; font-size: 12px"></el-input>
                      </div>
                    </div>
                    <div class="error" v-if="show_error_on_empty && !$v.mobile_number.required">Field is required</div>
                    <div class="error" v-if="mobile_number && !isValidMobileNumber">Mobile number must be {{ getMaxLength() }} digits for the selected country code</div>
                  </div>

                  <div class="bottom-margin-10" v-if="is_otp_sent">
                    <div
                      class="form-group"
                      :class="{
                        'not-empty': mobile_otp.length,
                        'form-group--error': show_error_on_empty && $v.mobile_otp.$error,
                      }"
                    >
                      <el-input type="text" size="small" class="form-control" placeholder="Mobile OTP" v-model="mobile_otp" @input="setMobileOtp($event)"></el-input>
                    </div>
                    <div class="error" v-if="show_error_on_empty && !$v.mobile_otp.required">Field is required</div>
                    <div style="color: red; font-size: 0.75em" v-else-if="mobile_otp.length && show_error_on_empty && mo_no_validation">Mobile number be valid numbers only</div>
                  </div>
                </div>

                <div class="top-margin-5 agreement-checkbox">
                  <el-checkbox v-model="notification_permission" disabled>
                    I accept
                    <router-link to="/retail-side/terms-condition" style="color: #2d2e8d; text-decoration: none; font-weight: 600">terms and conditions</router-link>
                    & Allow StockAnts
                    <br />
                    to send notifications
                  </el-checkbox>
                </div>
                <div>
                  <!-- Checkbox will only be shown if broker.model_type is not 'STOCKANTS_AUTH' -->
                  <el-checkbox v-if="!isSmartDeltaModel" v-model="sebi_expert">I am a SEBI Expert</el-checkbox>
                </div>
                <div class="font-06rem cursor-pointer text-left top-margin-10" style="color: #000">
                  <span style="color: #000; font-weight: 500">Note:</span>
                  Enter your
                  <span style="color: green">WhatsApp Number</span>
                  for further communication
                </div>

                <div class="text-center top-margin-15" v-if="is_otp_sent">
                  <el-button rounded class="btn-secondary-theme-filled" size="mini" style="width: 100%" v-on:click="verifyOtpForSignUp()" :loading="is_verify_otp_btn_loading">Verify OTP</el-button>
                </div>
                <div class="text-center top-margin-15" v-else>
                  <el-button rounded class="btn-secondary-theme-filled" size="mini" style="width: 100%" v-on:click="generateOtpForSignUp()" :loading="is_verify_otp_btn_loading">Generate OTP</el-button>
                </div>

                <div class="flex-space-between font-07rem top-margin-5" v-if="is_otp_sent">
                  <div style="color: #2d2e8d; cursor: pointer; font-weight: 500" @click="resetUserName()">Change Number</div>
                  <div style="color: #2d2e8d; cursor: pointer; font-weight: 500" @click="generateOtpForSignUp()">Resend OTP</div>
                </div>

                <div v-if="sign_up_form && allowed_authentication.credential_enable" class="font-07rem font-weight-600 cursor-pointer text-center top-margin-10">
                  Already verified ?
                  <span @click="toggleForm('signIn')" class="external-link-color">Log In</span>
                </div>
              </div>
            </div>
            <div class="top-margin-10" v-if="userType.length && !isRigiUser">
              <div class="text-center" v-if="allowed_authentication.google_enable">
                <div style="width: 20%; display: inline-block; border-bottom: 1px solid #ddd"></div>
                <div style="width: 10%; display: inline-block; font-size: 0.8rem; color: #9b9898; position: relative; top: 4px">Or</div>
                <div style="width: 20%; display: inline-block; border-bottom: 1px solid #ddd"></div>
              </div>

              <div>
                <div v-if="sign_in_form && is_broker_login && !isSmartDeltaModel && allowed_authentication.credential_enable" class="font-08rem font-weight-600 cursor-pointer text-center top-margin-20" style="color: #2d2e8d" @click="toggleLoginType()">Login with Mobile Or Email</div>
                <div>
                  <div class="top-margin-15 font-08rem google-btn" style="cursor: pointer" ref="googleSignIn" v-if="allowed_authentication.google_enable">
                    <span style="color: #000" class="flex-center">
                      <img src="../assets/images/login/google.png" style="width: 25px; margin-right: 3px" />
                      Continue with Google
                    </span>
                  </div>
                </div>

                <div v-if="sign_in_form && !is_broker_login && !isSmartDeltaModel" class="font-08rem font-weight-600 cursor-pointer text-center top-margin-20" style="color: #2d2e8d" @click="toggleLoginType()">Login with Broker</div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- video dialog -->
    <div id="video-section">
      <el-dialog :visible.sync="videoDialog" center :before-close="videoDialogClose">
        <iframe id="videoId" width="100%" height="600px" src="https://youtube.com/embed/QkUAhPDy81I" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import { loginNetworkCallBack } from '../mixins/login.NetworkCallback';
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
import { HelperNetworkCallBack } from '../mixins/Helper';
import CripNotice from 'crip-vue-notice';

export default {
  name: 'Login',

  mixins: [loginNetworkCallBack, HelperNetworkCallBack],

  data() {
    return {
      videoDialog: false,
      show_password: false,
      is_valid_email_error: false,
      password_regex_error: false,
      terms_and_conditions: false,
      sebi_expert: false,
      notification_permission: true,
      checked: true,
      username: '',
      mobile_number: '',
      full_name: '',
      managerId: '',
      password: '',
      // confirmPassword: "",
      remember_me: false,
      sign_in_form: true,
      sign_up_form: false,
      show_error_on_empty: false,
      password_not_matched_error: false,
      accept_terms_and_conditions_error: false,
      notification_permission_error: false,
      is_login_btn_loading: false,
      is_sign_up_btn_loading: false,
      referral_code: '',
      referral_code_error: false,
      is_brokers_list_loading: false,
      brokers_list: [],
      is_broker_login: false,
      allowed_authentication: {
        google_enable: false,
        fb_enable: false,
        credential_enable: false,
      },
      serverHostName: serverHostName,
      userType: 'Retail Investor',
      websiteUserType: {},
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
      currentEnvironment: {},
      isAngelone: false,
      isSmartDeltaModel: false,
      isRigiUser: false,
      is_verify_otp_btn_loading: false,
      broker_id: localStorage.getItem('selected_broker') ? Number(localStorage.getItem('selected_broker')) : null,
      show_error_on_empty: false,
      mobile_otp: '',
      is_otp_sent: false,
      mo_no_validation: false,
      emailUsername: false,
      mobileUsername: false,
      broker_search_query: '',
      filtered_brokers: [],
      model_type: '',
      isValidMobileNumber: true,
      selectedCountryCode: '+91',
      countryCodes: [
        {
          name: 'India',
          country_code: '+91',
          flag: require('@/assets/images/Country-flags/India.svg'),
          length: 10,
        },
        {
          name: 'Singapore',
          country_code: '+65',
          flag: require('@/assets/images/Country-flags/Singapore.svg'),
          length: 8,
        },
        {
          name: 'United States',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/United States.svg'),
          length: 10,
        },
        {
          name: 'Canada',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/Canada.svg'),
          length: 10,
        },
        {
          name: 'Dubai',
          country_code: '+971',
          flag: require('@/assets/images/Country-flags/Dubai.svg'),
          length: 9,
        },
        {
          name: 'Saudi Arabia',
          country_code: '+966',
          flag: require('@/assets/images/Country-flags/Saudi Arabia.svg'),
          length: 9,
        },
        {
          name: 'Oman',
          country_code: '+968',
          flag: require('@/assets/images/Country-flags/Oman.svg'),
          length: 8,
        },
        {
          name: 'United Kingdom',
          country_code: '+44',
          flag: require('@/assets/images/Country-flags/United Kingdom.svg'),
          length: 10,
        },
        {
          name: 'Australia',
          country_code: '+61',
          flag: require('@/assets/images/Country-flags/Australia.svg'),
          length: 9,
        },
      ],
    };
  },
  computed: {
    selectedCountry() {
      return this.countryCodes.find((country) => country.country_code === this.selectedCountryCode) || null;
    },
  },
  watch: {
    'allowed_authentication.google_enable'(newVal, oldVal) {
      this.googleLogin();
    },
    broker_search_query(newTitle) {
      const lowerCaseFilter = newTitle.toLowerCase();
      this.filtered_brokers = this.brokers_list.filter((obj) => obj.title.toLowerCase().includes(lowerCaseFilter));
    },
    username(newValue, oldValue) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const phonePattern = /^\d{6,10}$/; // Adjust pattern for different formats if needed

      if (emailPattern.test(this.username)) {
        this.emailUsername = true;
      } else if (phonePattern.test(this.username)) {
        this.mobileUsername = true;
      } else {
        this.mobileUsername = false;
        this.emailUsername = false;
      }

      return emailPattern.test(this.username) || phonePattern.test(this.username);
    },

    password(newValue, oldValue) {
      // let regularExpression = /^(?=.*[a-zA-Z])(?=.*[0-9]).+$/;
      let regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
      if (newValue && this.sign_up_form) {
        if (regularExpression.test(newValue)) {
          this.password_regex_error = false;
        } else {
          this.password_regex_error = true;
        }
      }
    },

    // referral_code(newValue, oldValue) {
    //   let regularExpression = /^(?=.*[A-Z])(?=.*[0-9])/;
    //   if (newValue.trim() && this.sign_up_form) {
    //     if (regularExpression.test(newValue)) {
    //       this.referral_code_error = false;
    //     } else {
    //       this.referral_code_error = true;
    //     }
    //   } else {
    //     this.referral_code_error = false;
    //   }
    // },
    sebi_expert() {
      this.userType = this.sebi_expert ? 'Market Expert' : 'Retail Investor';
    },
  },

  validations() {
    const emailOrPhone = (value) => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const phonePattern = /^\d{6,10}$/; // Adjust pattern for different formats if needed
      return emailPattern.test(value) || phonePattern.test(value);
    };

    return {
      username: {
        required,
        emailOrPhone,
      },
      managerId: {
        required,
      },
      password: {
        required,
      },
      mobile_number: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
      mobile_otp: {
        required,
      },
      full_name: {
        required,
      },
      terms_and_conditions: {
        required,
      },
    };
  },

  created() {

    // after logout save currentUrl
    if (!localStorage.getItem('currentUrl') || !localStorage.getItem('currentEnvironment')) {
      this.selectUserType();
    }

    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    }
    if (this.currentEnvironment && this.currentEnvironment.utm_source === 'Findoc') {
      this.$router.push('/'); // Redirect to home if findoc
    }

    if (this.$route.params.plan == 'register' || this.$route.query.referral) {
      this.sign_up_form = true;
      this.sign_in_form = false;
    } else {
      this.sign_up_form = false;
      this.sign_in_form = true;
    }

    if (this.$route.query.code) {
      let token = this.$route.query.code ? this.$route.query.code : '';
      this.sendTokenToServer(token);
    } else {
      this.getBrokersList();
    }

    if (this.$route.query.secure_token && this.currentEnvironment && this.currentEnvironment.utm_source == 'Share India Trade') {
      this.sendSecureTokenToShareIndia();
    }

    if (this.$route.query.referral) {
      this.referral_code = this.$route.query.referral;
    }
  },
  mounted() {
    // if (localStorage.getItem('currentEnvironment')) {
    //   this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    // }

    if (localStorage.getItem('websiteUserType')) {
      this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));

      this.isAngelone = window.location.href.includes('angelone') ? true : false;
      if (this.websiteUserType.userType == 'broker' || this.isAngelone) {
        this.userType = 'Retail Investor';
      }
    }

    // checked Widget details in query params
    if (this.$route.query.widget_access) {
      var route_to_be = this.$route.query.widget_access == 'Locked' ? '/pricing' : '/experts-past-recommendations';

      localStorage.setItem('route_to_be', route_to_be);
      this.userType = 'Retail Investor';

      if (this.$route.query.brokerId.length != 0 && JSON.parse(this.$route.query.bl_api_integrated)) {
        this.is_broker_login = true;
        this.sign_in_form = false;
        this.sign_up_form = false;
      } else {
        this.sign_in_form = false;
        this.is_broker_login = false;
        this.sign_up_form = true;
      }

      if (this.$route.query.brokerId == 40) {
        this.isSmartDeltaModel = true;
      }

      setTimeout(() => {
        localStorage.setItem('selected_broker', Number(this.$route.query.brokerId));

        this.broker_id = Number(this.$route.query.brokerId);
      }, 1000);
    }

    // to set STOCKANTS AUTH
    if ((this.currentEnvironment && this.currentEnvironment.isStockAntsAuth) || this.isSmartDeltaModel) {
      this.isSmartDeltaModel = true;
      this.sign_in_form = true;
      this.sign_up_form = false;
      this.is_broker_login = false;
      this.model_type = 'STOCKANTS_AUTH';
    }

    //  SIO means Sign in only
    if (this.$route.query.userWith == 'SIO') {
      this.userType = 'Retail Investor';
      this.is_broker_login = false;
      this.sign_in_form = true;
      this.sign_up_form = false;
      this.isRigiUser = true;
    }
  },

  methods: {
    sendSecureTokenToShareIndia() {
      var redirectUrl = window.location.href;
      serverAddr
        .post(`/auth/v1/share_india_request_token_redirect_url`, {
          url: redirectUrl,
        })
        .then((response) => {
          if (response.data.status) {
            window.location.href = response.data.data.redirect_url;
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_brokers_list_loading = false; //disabled loader
        });
    },
    // Get the max length for the selected country code
    getMaxLength() {
      const selectedCountry = this.countryCodes.find((country) => country.country_code === this.selectedCountryCode);
      return selectedCountry ? selectedCountry.length : 10; // Default to 10 if not found
    },
    // Validate the mobile number length
    validateMobileNumber() {
      const maxLength = this.getMaxLength();
      this.isValidMobileNumber = this.mobile_number.length === maxLength;
    },
    async sendTokenToServer(token_id) {
      this.is_brokers_list_loading = true; //enabled loader
      var redirectUrl = '';

      let broker_id;
      broker_id = Number(localStorage.getItem('selected_broker'));

      if (this.currentEnvironment.utm_source == 'Share India Trade') {
        redirectUrl = window.location.href;
      } else {
        redirectUrl = `?success=true&requestToken=${token_id}&state=login`;
      }

      if (broker_id) {
        await serverAddr
          .post(`auth/v1/level_two_auth_for_broker`, {
            broker_id: Number(broker_id),
            token_id: token_id,
            url: redirectUrl,
            profession: 'RETAIL_INVESTOR',
          })
          .then((response) => {
            this.loginUserNetworkCallBack(response);
            this.is_brokers_list_loading = false; //disabled loader
          })
          .catch((error) => {
            console.log(error);
            this.is_brokers_list_loading = false; //disabled loader
          });
      }

      this.getBrokersList();
    },
    resetUserName() {
      this.show_error_on_empty = false;
      this.is_otp_sent = false;
      (this.mobile_number = ''), (this.username = '');
    },

    generateOtpForSignUp() {
      this.selectedCountryCode;
      this.$v.mobile_number.$touch();
      this.$v.full_name.$touch();

      this.mobile_otp = '';
      this.show_error_on_empty = true;
      this.is_verify_otp_btn_loading = true;

      if (this.full_name.trim().length && this.mobile_number.trim().length && !this.mo_no_validation) {
        this.generateOtp('signUp');
      } else {
        this.is_verify_otp_btn_loading = false;

        new CripNotice({
          title: 'Oops! Something went wrong!',
          description: 'Please fill all required details',
          type: 'error',
          duration: 2,
        });
      }
    },

    verifyOtpForSignUp() {
      this.show_error_on_empty = true;
      this.$v.mobile_otp.$touch();

      if (this.mobile_otp.trim().length) {
        this.is_verify_otp_btn_loading = true;
        this.verifyOtp('signUp');
      }
    },

    generateOtpForLogin() {
      this.$v.username.$touch();
      this.$v.mobile_otp.$reset();
      this.mobile_otp = '';
      this.show_error_on_empty = true;
      this.is_login_btn_loading = true;

      if (this.username.trim().length && this.mobileUsername) {
        this.is_verify_otp_btn_loading = true;
        this.generateOtp('signIn');
      }
    },

    verifyOtpForLogin() {
      this.show_error_on_empty = true;
      this.$v.mobile_otp.$touch();

      if (this.mobile_otp.trim().length) {
        this.is_verify_otp_btn_loading = true;
        this.verifyOtp('signIn');
      }
    },

    async generateOtp(method) {
      var payload = {};
      if (method == 'signIn') {
        payload = {
          country_code: this.selectedCountryCode,
          mobile: this.username,
          purpose: 'SIGN_IN',
        };
        // if (this.isSmartDeltaModel) {
        //   payload.broker_id = Number(localStorage.getItem('selected_broker'));
        // }
      } else {
        payload = {
          country_code: this.selectedCountryCode,
          mobile: this.mobile_number,
          purpose: 'SIGN_UP',
        };
      }
      if (localStorage.getItem('selected_broker')) {
        payload.broker_id = Number(localStorage.getItem('selected_broker'));
      }
      try {
        const response = await serverAddr.post('/auth/v1/generate_mobile_otp', payload);
        if (response.data.status) {
          this.is_otp_sent = true;
          new CripNotice({
            title: 'Success',
            description: response.data.validation,
            type: 'success',
            duration: 3,
          });
        } else {
          if (response.data.message.includes('Account not found') && this.allowed_authentication.sign_up) {
            this.toggleForm('signUp');
          }
        }
      } catch (error) {
        console.error('Error generating OTP:', error);
      } finally {
        this.is_verify_otp_btn_loading = false;
        this.is_login_btn_loading = false;
      }
    },

    async verifyOtp(method) {
      var payload = {};
      if (method == 'signIn') {
        payload = {
          country_code: this.selectedCountryCode,
          mobile: this.username,
          mobile_otp: Number(this.mobile_otp),
          purpose: 'SIGN_IN',
          referral_code: this.referral_code ? this.referral_code : '',
        };
      } else {
        payload = {
          country_code: this.selectedCountryCode,
          mobile: this.mobile_number,
          mobile_otp: Number(this.mobile_otp),
          full_name: this.full_name,
          purpose: 'SIGN_UP',
          profession: this.userType == 'Retail Investor' ? 'RETAIL_INVESTOR' : 'MARKET_EXPERT',
          referral_code: this.referral_code ? this.referral_code : '',
          country_code: this.selectedCountryCode,
        };
      }

      // if (this.isSmartDeltaModel || (this.currentEnvironment && this.currentEnvironment.isStockAntsAuth)) {
      //   payload.broker_id = Number(localStorage.getItem('selected_broker'));
      // }

      if (localStorage.getItem('selected_broker')) {
        payload.broker_id = Number(localStorage.getItem('selected_broker'));
      }

      try {
        const response = await serverAddr.post('/auth/v1/validate_otp_and_perform_signin_signup', payload);
        if (response.data.status) {
          this.verifyOtpNetworkCallBack(response);
          // Add logic for successful OTP verification
        } else {
          this.show_error_on_empty = false;
          this.mobile_otp = '';

          if (response.data.message && response.data.message.includes('User already exists')) {
            this.toggleForm('signIn');
          }
        }
      } catch (error) {
        console.error('Error verifying OTP:', error);
        new CripNotice({
          title: 'Error',
          description: 'Please enter valid OTP',
          type: 'error',
          duration: 3,
        });
      } finally {
        this.is_verify_otp_btn_loading = false;
      }
    },

    changeProfession(user) {
      this.resetFields();
      this.userType = user;
      this.sign_in_form = true;
      this.sign_up_form = false;
      this.isSmartDeltaModel = false;
      this.isRigiUser = false;
      this.is_broker_login = this.userType == 'Retail Investor' ? true : false;
    },

    resetFields() {
      this.username = '';
      this.managerId = '';
      this.password = '';
      this.userType = '';
      this.isSmartDeltaModel = false;
      this.show_error_on_empty = false;
      this.broker_id = null;

      localStorage.removeItem('selected_broker');
    },

    googleLogin() {
      setTimeout(() => {
        window.gapi.load('auth2', () => {
          let element = this.$refs['googleSignIn'];

          const auth2 = window.gapi.auth2.init({
            // WILL NEED TO CHANGE BEFORE MAKING LIVE
            // client_id: "929805204561-vop60edk3dh66alqfcvtdnhkhejq9l83.apps.googleusercontent.com",
            client_id: '1091584009811-nch10s2crqsonpr1vvp58hgof9eqsgnd.apps.googleusercontent.com',
            scope: 'email openid',
            cookiepolicy: 'single_host_origin',
          });

          auth2.attachClickHandler(
            element,
            {},
            (googleUser) => {
              var profile = googleUser.getBasicProfile();

              var postData = {
                username: profile.getEmail(),
                sign_up_source: 'GMAIL',
                token: googleUser.getAuthResponse().id_token,
                full_name: profile.getName(),
                first_name: profile.getGivenName(),
                last_name: profile.getFamilyName(),
                profession: this.userType == 'Market Expert' ? 'MARKET_EXPERT' : 'RETAIL_INVESTOR',
                referral_code: this.referral_code ? this.referral_code : '',
              };

              // if (this.isSmartDeltaModel || (this.currentEnvironment && this.currentEnvironment.isStockAntsAuth)) {
              //   postData.broker_id = Number(localStorage.getItem('selected_broker'));
              // }
              if (localStorage.getItem('selected_broker')) {
                postData.broker_id = Number(localStorage.getItem('selected_broker'));
              }

              serverAddr
                .post('/auth/v1/sign_in_with_social', postData)
                .then((response) => {
                  this.socialLoginUserNetworkCallBack(response, profile.getEmail());
                })
                .catch(function (error) {
                  console.log(error);
                });
            },
            (error) => console.log(error)
          );
        });

        window.fbAsyncInit = function () {
          FB.init({
            appId: '1292261177910148',
            // appId      : '938002080014163',
            cookie: true,
            xfbml: true,
            version: 'v8.0',
          });

          FB.AppEvents.logPageView();
        };

        (function (d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = 'https://connect.facebook.net/en_US/sdk.js';
          fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
      }, 1000);
    },

    goToLink(link) {
      this.$router.push(link);
    },

    setUsername(value) {
      this.username = value;
    },

    setMobileOtp(value) {
      this.mobile_otp = value;
      this.$v.mobile_otp.$touch();
    },

    setMobileNumber(value) {
      if (value.length == 10) {
        this.show_error_on_empty = true;
      }

      if (value) {
        this.mobile_number = value.trim();
        this.$v.mobile_number.$touch();
        var numbers = /^[0-9]+$/;
        if (this.mobile_number.match(numbers)) {
          this.mo_no_validation = false;
        } else {
          this.mo_no_validation = true;
        }
      }
    },

    setFullName(value) {
      this.full_name = value;
      this.$v.full_name.$touch();
    },

    setPassword(value) {
      this.password = value;
      this.$v.password.$touch();
    },

    toggleLoginType() {
      this.is_broker_login = !this.is_broker_login;
      this.changeSignUpType();
    },

    changeSignUpType() {
      this.show_error_on_empty = false;
      this.password_regex_error = false;
      this.accept_terms_and_conditions_error = false;
      this.notification_permission_error = false;

      this.terms_and_conditions = false;
      // this.notification_permission = false;

      this.username = '';
      this.password = '';
      // this.confirmPassword = '';
    },

    toggleForm(form) {
      this.show_error_on_empty = false;
      this.is_verify_otp_btn_loading = false;
      this.password_regex_error = false;
      this.is_valid_email_error = false;
      this.accept_terms_and_conditions_error = false;
      this.notification_permission_error = false;
      this.show_password = false;
      this.is_broker_login = false;
      this.terms_and_conditions = false;
      // this.notification_permission = false;
      this.is_otp_sent = false;
      this.mobileUsername = false;
      this.emailUsername = false;
      this.userType = 'Retail Investor';
      this.sebi_expert = false;

      this.full_name = '';
      this.mobile_otp = '';
      this.mobile_number = '';
      this.username = '';
      this.password = '';
      // this.confirmPassword = "";

      if (form == 'signIn') {
        this.sign_up_form = false;
        this.sign_in_form = true;
      } else {
        this.sign_in_form = false;
        this.sign_up_form = true;
      }

      // if (this.$route.query.referral) {
      //   this.referral_code = this.$route.query.referral;
      // }
    },

    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById('videoId');
      let url = video.getAttribute('src');
      video.setAttribute('src', '');
      video.setAttribute('src', url);
    },

    getBrokersList() {
      this.is_brokers_list_loading = true; //enabled loader

      serverAddr
        .post('/auth/v1/broker/list')
        .then((response) => {
          if (response.data.status && response.data.data.length) {
            this.brokers_list = response.data.data;

            // Remove zerodha on title
            this.brokers_list = response.data.data.filter((item) => item.title !== 'Zerodha');

            this.filtered_brokers = this.brokers_list;

            this.allowed_authentication = response.data.auth_option;

            if (!this.allowed_authentication.credential_enable) {
              this.is_broker_login = true;
            }
          }
          this.is_brokers_list_loading = false; //disabled loader
        })
        .catch((error) => {
          console.log(error);
          this.is_brokers_list_loading = false; //disabled loader
        });
    },

    getRedirectURLForBroker(broker) {
      localStorage.setItem('selected_broker', broker.id);

      this.broker_id = Number(broker.id);

      if (broker.redirection_url && broker.model_type == 'STOCKANTS_AUTH' && !this.currentUrl.includes(broker.redirection_url)) {
        window.location.href = broker.redirection_url;
      } else if (broker.model_type != 'STOCKANTS_AUTH') {
        this.is_brokers_list_loading = true; //enabled loader
        serverAddr
          .get(`auth/v1/level_one_auth_for_broker?broker_id=${broker.id}`)
          .then((response) => {
            if (response.data.status) {
              window.location.href = response.data.data.redirect_url;
            }

            this.is_brokers_list_loading = false; //disabled loader
          })
          .catch((error) => {
            console.log(error);
            this.is_brokers_list_loading = false; //disabled loader
          });
      } else if (broker.model_type == 'STOCKANTS_AUTH') {
        this.isSmartDeltaModel = true;
        this.sign_in_form = true;
        this.is_broker_login = false;
        this.model_type = 'STOCKANTS_AUTH';
      }
    },

    login() {
      var authType = '';
      if (this.userType == 'Retail Investor') {
        authType = 'RETAIL_INVESTOR';
      } else if (this.userType == 'Market Expert') {
        authType = 'MARKET_EXPERT';
      }

      this.show_error_on_empty = true;
      this.$v.$touch();
      if (this.username.trim() && this.password) {
        this.is_login_btn_loading = true;
        serverAddr
          .post('/auth/v1/sign_in', {
            username: this.username,
            password: this.password,
            sign_in_with: 'EMAIL',
            profession: authType,
            referral_code: this.referral_code ? this.referral_code : '',
          })
          .then((response) => {
            if (response.data.status) {
              this.loginUserNetworkCallBack(response);
            } else {
              this.show_error_on_empty = false;
              this.mobile_otp = '';

              if (response.data.validation.includes('User account not exists') && this.allowed_authentication.sign_up) {
                this.toggleForm('signUp');
              }
            }
            this.is_login_btn_loading = false;
          })
          .catch(
            function (error) {
              console.log(error);
              this.is_login_btn_loading = false;
            }.bind(this)
          );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.background-image {
  background-image: url('../assets/images/login/desktop_bg.png');
  height: 100vh;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;
  position: relative;
  z-index: 1;
}

.social-media-authentication-btn-section {
  margin: 20px 0 20px 0;
}

.Login {
  .google-btn {
    color: rgb(0 0 0);
    padding: 8px;
    border: 1px solid #cdcdcd;
    border-radius: 4px;
    font-weight: 600;
  }

  .box-card {
    margin: 18px 5px 5px;
    box-shadow: 0 2px 12px 0 #09090947;
  }

  .btn-secondary-theme-borderd {
    padding: 7px 15px;
  }

  .user-type-section {
    .button-outer {
      display: flex;
      margin: 25px 0;

      .user-type-button {
        padding: 10px 15px 10px 20px;
        border: 1px solid #f0f0f0;
        border-radius: 10px;
        background: #f0f0f0;
        font-weight: 600;
        color: #7e7e7e;
        font-size: 14px;
        width: 100%;
        height: 40px;
        align-items: center;
        display: flex;
        cursor: pointer;
      }

      .vertical-line {
        padding: 3px;
        border-radius: 7px 0 0 7px;
        position: relative;
        left: 6px;
        height: 48px;
        top: 4px;
      }

      .user-type-button:hover {
        color: #ffff;
        font-size: 16px;
      }
    }

    .red {
      .user-type-button:hover,
      .vertical-line {
        background-color: red;
      }
    }

    .blue {
      .user-type-button:hover,
      .vertical-line {
        background-color: #2d2e8d;
      }
    }

    .purple {
      .user-type-button:hover,
      .vertical-line {
        background-color: #bf46f8;
      }
    }
  }

  .login-card-position {
    position: fixed;
    top: 50%;
    right: 8%;
    transform: translate(0%, -50%);
    min-width: 400px;
    z-index: 9;
  }

  .broker-card-section {
    padding: 0 15px 0px 0;
    max-height: 165px;
    overflow-y: scroll;
  }

  .broker-card-section::-webkit-scrollbar {
    width: 6px;
  }

  .broker-card-section::-webkit-scrollbar-track {
    background: #f8f8f8;
    border-radius: 10px;
  }

  /* Handle */
  .broker-card-section::-webkit-scrollbar-thumb {
    background: #d4d3d3;
    border-radius: 10px;
  }

  /* Handle on hover */
  .broker-card-section::-webkit-scrollbar-thumb:hover {
    background: #bab9b9;
  }
}

.form-container {
  margin: 15px 0 0 0;
}

.input-group-section {
  margin-bottom: 16px;
}

.password-visibility {
  position: absolute;
  right: 10px;
  top: 9px;
  width: 15px;
  cursor: pointer;
  z-index: 1;
}

.paytm-footer {
  text-align: center;
  color: #2d2e8d;
  font-weight: 600;
  margin-top: 20px;
  font-size: 0.9rem;

  .para {
    font-size: 0.65rem;
    font-weight: 500;
  }
}

.premium_plan_message {
  margin-top: 20px;

  .inner {
    display: flex;
    align-items: end;

    .offer-icon {
      width: 100px;
    }

    .first-head {
      font-size: 0.9rem;
      color: #d45a0e;
      font-weight: 600;
    }

    .second-head {
      font-size: 0.7rem;
      color: #2d2e8d;
      font-weight: 500;
    }

    .video-icon {
      .know-more {
        border-bottom: 1px solid;
        margin-right: 5px;
      }
    }
  }
}

@media screen and (max-width: 1160px) {
  .Login {
    .login-card-position {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .background-image {
      background-image: url('../assets/images/login/mobilebg.png');
    }

    .login-card {
      .el-card__body {
        padding: 20px;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .Login .login-card-position {
    width: 100%;
  }

  .Login .login-card {
    width: 80%;
    margin: 0 auto;
  }

  .Login .broker-card-section {
    padding: 0 0px 20px 0px;
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.Login {
  .agreement-checkbox {
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #2d2e8d;
      border-color: #2d2e8d;
    }

    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
      border-color: #ffffff;
    }

    .el-checkbox__input {
      position: relative;
      bottom: 18px;
    }
  }
}

.Login {
  .el-input-group__prepend {
    background-color: #ffffff;
    color: #000000;
    font-weight: 600;
    border: 1px solid #dcdfe6;
    border-right: none;
  }
}

.Login .broker-card {
  border-radius: 10px;
  height: 53px;
  width: 145px;
  justify-content: flex-start;
  border: none;

  .el-card__body {
    padding: 10px 10px !important;
  }
}

.Login .login-card {
  min-height: 530px;
  border-radius: 10px;
  width: 400px;

  .search-input {
    width: 90%;
    margin: 20px 10px;

    .el-input__inner {
      border-radius: 15px;
    }

    .el-icon-search {
      position: relative;
      top: -1px;
    }
  }

  .el-card__body {
    padding: 20px 35px;
  }
}

.Login .el-button.is-loading:before {
  background-color: $primary-theme-color;
  position: relative;
}

.Login .el-button .el-icon-loading {
  font-weight: bold;
}

.Login {
  .el-checkbox__label {
    color: #000;
    font-size: 0.7rem;
    position: relative;
    top: -1px;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: $secondary-theme-color;
    border-color: $secondary-theme-color;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: $secondary-theme-color;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: $secondary-theme-color;
    background: $secondary-theme-color;
  }

  .el-radio {
    margin-right: 20px;
  }

  .el-radio__label {
    font-size: 13px;
  }
}
@media screen and (max-width: 500px) {
  .Login .login-card .el-card__body {
    padding: 20px 15px;
  }
}
</style>